/**
 * Category Create Component
 * Form for creating new card categories
 */

import {
  Create,
  SimpleForm,
  TextInput,
  SelectInput,
  NumberInput,
  required,
} from 'react-admin';
import { Typography, Box } from '@mui/material';
import { LAYER_CHOICES } from '../constants';

export function CategoryCreate() {
  return (
    <Create title="Create Category">
      <SimpleForm>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
          <Typography variant="h6" gutterBottom>New Category</Typography>

          <TextInput
            source="categoryId"
            label="Category ID"
            validate={required()}
            helperText="Unique identifier (e.g., 'relationship_dynamics')"
          />

          <TextInput
            source="categoryName"
            label="Category Name"
            validate={required()}
            fullWidth
          />

          <SelectInput
            source="layer"
            label="Layer"
            choices={LAYER_CHOICES}
            validate={required()}
            defaultValue="Psychological_Assessment"
            sx={{ minWidth: 250 }}
          />

          <TextInput
            source="description"
            label="Description"
            multiline
            rows={2}
            validate={required()}
            fullWidth
          />

          <TextInput
            source="toneGuidance"
            label="Tone Guidance"
            multiline
            rows={3}
            validate={required()}
            fullWidth
          />

          <NumberInput
            source="sensitivityOrder"
            label="Sensitivity Order"
            helperText="Lower = less sensitive, Higher = more sensitive"
            defaultValue={50}
          />
        </Box>
      </SimpleForm>
    </Create>
  );
}
